import { createSlice } from '@reduxjs/toolkit';
import api from './api';
import { ReducerGuests } from './types';

export const GET_COURSES_BY_GUEST = (params) => async (dispatch) => {
  const res = await api.getCoursesByGuest(params)
  dispatch({ type: ReducerGuests.SET_GUEST_COURSES, data: res.data, meta: res })
}

export const GET_COURSES_DETAIL_BY_GUEST = (params) => async (dispatch) => {
  const res = await api.getCoursesDetailByGuest(params)
  const exams = await api.getExamsByCourseByGuest(params)
  dispatch({ type: ReducerGuests.SET_GUEST_COURSES_DETAIL, data: res.data, exams: exams.data })
}

const guestsReducer = createSlice({
  name: 'guests',
  initialState: {
    lists: [],
    course_detail: {},
    exams: []
  },
  extraReducers: {
    [ReducerGuests.SET_GUEST_COURSES]: (state, action) => {
      state.lists = action.data
      state.meta = action.meta
    },
    [ReducerGuests.SET_GUEST_COURSES_DETAIL]: (state, action) => {
      state.course_detail = action.data
      state.exams = action.exams
    },
  },
})

const { reducer } = guestsReducer
export default reducer
